module.exports = __webpack_public_path__ + "NexaBlack.6ee3d1b7a06d64515117.ttf";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/fonts/NexaBlack.ttf
// module id = ../../../../../src/assets/fonts/NexaBlack.ttf
// module chunks = 2